var map = {
	"./acapulco-B.png": 18784,
	"./acapulco-CLR.png": 67724,
	"./acapulco-N.png": 32020,
	"./angelesverdes-B.png": 39164,
	"./angelesverdes-CLR.png": 22288,
	"./angelesverdes-N.png": 94924,
	"./atlasturistico-B.png": 66292,
	"./atlasturistico-CLR.png": 21692,
	"./atlasturistico-N.png": 24996,
	"./calendario-B.png": 85292,
	"./calendario-CLR.png": 54724,
	"./calendario-N.png": 19524,
	"./carteleracultural-B.png": 63055,
	"./carteleracultural-CLR.png": 39996,
	"./doll.png": 50072,
	"./experiencias-B.png": 29044,
	"./experiencias-CLR.png": 75004,
	"./experiencias-N.png": 16840,
	"./facebook-CLR.png": 924,
	"./gafsacomm-B.png": 18996,
	"./gafsacomm-CLR.png": 73424,
	"./gafsacomm-N.png": 60404,
	"./guiaturistica-B.png": 93376,
	"./guiaturistica-CLR.png": 56400,
	"./guiaturistica-N.png": 84196,
	"./instagram-CLR.png": 24984,
	"./islamaria-B.png": 95508,
	"./islamaria-CLR.png": 15076,
	"./islamaria-N.png": 58036,
	"./mexicana-B.png": 26132,
	"./mexicana-CLR.png": 23340,
	"./mexicana-N.png": 70188,
	"./pueblosmagicos-B.png": 48108,
	"./pueblosmagicos-CLR.png": 29092,
	"./pueblosmagicos-clr.svg": 97732,
	"./reproduccion-B.png": 62847,
	"./reproduccion-CLR.png": 98700,
	"./reproduccion-N.png": 85496,
	"./rnt-B.png": 62728,
	"./rnt-CLR.png": 19948,
	"./rnt-N.png": 99220,
	"./tiktok-CLR.png": 23444,
	"./trenmaya-B.png": 86412,
	"./trenmaya-CLR.png": 27144,
	"./trenmaya-N.png": 63432,
	"./turismoxico-B.png": 47596,
	"./turismoxico-CLR.png": 4860,
	"./turismoxico-N.png": 83683,
	"./x-CLR.png": 10199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54420;